const RANK_ICONS: Record<string, string> = {
	BRONZE: 'assets/images/ranks/rank_bronze.png',
	SILVER: 'assets/images/ranks/rank_silver.png',
	GOLD: 'assets/images/ranks/rank_gold.png',
	PLATINUM: 'assets/images/ranks/rank_platinum.png',
	EMERALD: 'assets/images/ranks/rank_emerald.png',
	DIAMOND: 'assets/images/ranks/rank_diamond.png',
	MASTER: 'assets/images/ranks/rank_master.png',
	GRANDMASTER: 'assets/images/ranks/rank_gm.png',
	GM: 'assets/images/ranks/rank_gm.png',
	CHAMPION: 'assets/images/ranks/rank_champion.png',
};

export function rankIcon(code: string): string {
	return RANK_ICONS[code.toUpperCase()] ?? 'assets/images/ranks/rank_bronze.png';
}
